import * as React from "react";
import { CollapseContext } from "../collapse-provider/collapse-provider.mjs";
const _CollapseTrigger = class _CollapseTrigger extends React.Component {
  constructor() {
    super(...arguments);
    this.enhanceItem = (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          ref: this.context.triggerRef,
          isActive: this.context.isVisible,
          onClick: (event) => {
            event.preventDefault();
            if (this.context.onToggle) {
              this.context.onToggle();
            }
          },
          onKeyDown: (event) => {
            if (event.key === " ") {
              event.preventDefault();
              if (this.context.onToggle) {
                this.context.onToggle();
              }
            }
          },
          url: "#" + this.context.id,
          "aria-expanded": this.context.isVisible,
          "aria-controls": this.context.id,
          role: "button"
        });
      }
    };
  }
  render() {
    var _a;
    const children = React.Children.map(this.props.children, this.enhanceItem);
    const child = (_a = children == null ? void 0 : children[0]) != null ? _a : null;
    return child ? React.Children.only(child) : null;
  }
};
_CollapseTrigger.contextType = CollapseContext;
let CollapseTrigger = _CollapseTrigger;
export {
  CollapseTrigger
};
